import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { getRangeValue } from "../Utils/NumberUtils";
import { isSsr } from "../Utils/Utils";
export var Retina = /*#__PURE__*/function () {
  function Retina(container) {
    _classCallCheck(this, Retina);
    this.container = container;
  }
  _createClass(Retina, [{
    key: "init",
    value: function init() {
      var _this = this;
      var container = this.container,
        options = container.actualOptions;
      this.pixelRatio = !options.detectRetina || isSsr() ? 1 : window.devicePixelRatio;
      var motionOptions = this.container.actualOptions.motion;
      if (motionOptions && (motionOptions.disable || motionOptions.reduce.value)) {
        if (isSsr() || typeof matchMedia === "undefined" || !matchMedia) {
          this.reduceFactor = 1;
        } else {
          var mediaQuery = matchMedia("(prefers-reduced-motion: reduce)");
          if (mediaQuery) {
            this.handleMotionChange(mediaQuery);
            var handleChange = function handleChange() {
              _this.handleMotionChange(mediaQuery);
              container.refresh().catch(function () {});
            };
            if (mediaQuery.addEventListener !== undefined) {
              mediaQuery.addEventListener("change", handleChange);
            } else if (mediaQuery.addListener !== undefined) {
              mediaQuery.addListener(handleChange);
            }
          }
        }
      } else {
        this.reduceFactor = 1;
      }
      var ratio = this.pixelRatio;
      if (container.canvas.element) {
        var element = container.canvas.element;
        container.canvas.size.width = element.offsetWidth * ratio;
        container.canvas.size.height = element.offsetHeight * ratio;
      }
      var particles = options.particles;
      this.attractDistance = getRangeValue(particles.move.attract.distance) * ratio;
      this.linksDistance = particles.links.distance * ratio;
      this.linksWidth = particles.links.width * ratio;
      this.sizeAnimationSpeed = getRangeValue(particles.size.animation.speed) * ratio;
      this.maxSpeed = getRangeValue(particles.move.gravity.maxSpeed) * ratio;
      var modes = options.interactivity.modes;
      this.connectModeDistance = modes.connect.distance * ratio;
      this.connectModeRadius = modes.connect.radius * ratio;
      this.grabModeDistance = modes.grab.distance * ratio;
      this.repulseModeDistance = modes.repulse.distance * ratio;
      this.bounceModeDistance = modes.bounce.distance * ratio;
      this.attractModeDistance = modes.attract.distance * ratio;
      this.slowModeRadius = modes.slow.radius * ratio;
      this.bubbleModeDistance = modes.bubble.distance * ratio;
      if (modes.bubble.size) {
        this.bubbleModeSize = modes.bubble.size * ratio;
      }
    }
  }, {
    key: "initParticle",
    value: function initParticle(particle) {
      var options = particle.options,
        ratio = this.pixelRatio,
        moveDistance = options.move.distance,
        props = particle.retina;
      props.attractDistance = getRangeValue(options.move.attract.distance) * ratio;
      props.linksDistance = options.links.distance * ratio;
      props.linksWidth = options.links.width * ratio;
      props.moveDrift = getRangeValue(options.move.drift) * ratio;
      props.moveSpeed = getRangeValue(options.move.speed) * ratio;
      props.sizeAnimationSpeed = getRangeValue(options.size.animation.speed) * ratio;
      var maxDistance = props.maxDistance;
      maxDistance.horizontal = moveDistance.horizontal !== undefined ? moveDistance.horizontal * ratio : undefined;
      maxDistance.vertical = moveDistance.vertical !== undefined ? moveDistance.vertical * ratio : undefined;
      props.maxSpeed = getRangeValue(options.move.gravity.maxSpeed) * ratio;
    }
  }, {
    key: "handleMotionChange",
    value: function handleMotionChange(mediaQuery) {
      var options = this.container.actualOptions;
      if (mediaQuery.matches) {
        var motion = options.motion;
        this.reduceFactor = motion.disable ? 0 : motion.reduce.value ? 1 / motion.reduce.factor : 1;
      } else {
        this.reduceFactor = 1;
      }
    }
  }]);
  return Retina;
}();